module.exports = Promise.all([__parcel__import__("dCTWJ"), __parcel__import__("gJDwL")]).then(() => parcelRequire('g36Vt'));